// client/src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  // LanguageDetector is removed to prevent it from overriding 'el'
  .use(initReactI18next)
  .init({
    // --- CRUCIAL FIX: Force Greek language ---
    lng: 'el',             // Explicitly sets the current language to Greek
    fallbackLng: 'en',     // Falls back to English if Greek files fail to load
    supportedLngs: ['el', 'en'],
    
    // Define all namespaces (to ensure all translation files are loaded)
    ns: [
      'common',
      'business', 
      'wholesaler',
      'admin',
      'auth',
      'products',
      'orders',
      'legal'
    ],
    defaultNS: 'common',
    
    // The detection section is removed since we are no longer using LanguageDetector
    
    backend: {
      // Confirms the path where your JSON files are stored in the public folder
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    
    interpolation: {
      escapeValue: false // React already escapes
    },
    
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p']
    },

    // Development settings (Expose i18n object globally for debugging)
    debug: false, 
    
    // Formatting
    load: 'languageOnly', 
    
    // Performance and Missing Keys
    saveMissing: false,
    updateMissing: false,
    returnNull: false,
    returnEmptyString: false,
    returnObjects: false
  });

// Attach i18n object to window for easy debugging in the console
if (process.env.NODE_ENV === 'development') {
    window.i18n = i18n;
}

export default i18n;